export default {
  viewHomeWorks:[]
}



// WEBPACK FOOTER //
// ./src/store/axj_help/state.js